import axios from "../axiosInstance";

class RegionalService {
  async getRegionalList() {
    return await axios.get("regional/tower");
  }
}

export default new RegionalService();
